<template>
  <div class="top-bar">
    <b-navbar
      toggleable="lg"
      class="nav-item-content d-flex justify-content-between align-items-center"
    >
      <!--        <div class="nav-item-content d-flex justify-content-between align-items-center">-->
      <div class="qoute d-flex justify-content-start align-items-center">
        <span class="qoute-coma">
          <svg
            width="18"
            height="13"
            viewBox="0 0 18 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.3125 6.5H13.5V4.78571C13.5 3.84018 14.509 3.07143 15.75 3.07143H16.0312C16.4988 3.07143 16.875 2.78482 16.875 2.42857V1.14286C16.875 0.786607 16.4988 0.5 16.0312 0.5H15.75C12.6422 0.5 10.125 2.41786 10.125 4.78571V11.2143C10.125 11.9241 10.8809 12.5 11.8125 12.5H16.3125C17.2441 12.5 18 11.9241 18 11.2143V7.78571C18 7.07589 17.2441 6.5 16.3125 6.5ZM6.1875 6.5H3.375V4.78571C3.375 3.84018 4.38398 3.07143 5.625 3.07143H5.90625C6.37383 3.07143 6.75 2.78482 6.75 2.42857V1.14286C6.75 0.786607 6.37383 0.5 5.90625 0.5H5.625C2.51719 0.5 0 2.41786 0 4.78571V11.2143C0 11.9241 0.755859 12.5 1.6875 12.5H6.1875C7.11914 12.5 7.875 11.9241 7.875 11.2143V7.78571C7.875 7.07589 7.11914 6.5 6.1875 6.5Z"
              fill="#557EFB"
            />
          </svg>
        </span>
        <h4 v-if="quote">
          "{{ quote.text }}" - <strong> {{ quote.author }}</strong>
        </h4>
      </div>
      <div class="actions d-flex justify-content-around align-items-center">
        <b-button size="sm" variant="outline-primary">
          <!--                <button class="btn-outline">-->
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.75 19.5H3C2.60218 19.5 2.22064 19.342 1.93934 19.0607C1.65804 18.7794 1.5 18.3978 1.5 18V6C1.5 5.60218 1.65804 5.22064 1.93934 4.93934C2.22064 4.65804 2.60218 4.5 3 4.5H15.75C16.1478 4.5 16.5294 4.65804 16.8107 4.93934C17.092 5.22064 17.25 5.60218 17.25 6V9.045L21.315 6.1425C21.4269 6.0628 21.5586 6.01538 21.6957 6.00543C21.8327 5.99547 21.9699 6.02336 22.0922 6.08605C22.2144 6.14874 22.3171 6.24382 22.3891 6.3609C22.461 6.47799 22.4994 6.61259 22.5 6.75V17.25C22.4994 17.3874 22.461 17.522 22.3891 17.6391C22.3171 17.7562 22.2144 17.8513 22.0922 17.9139C21.9699 17.9766 21.8327 18.0045 21.6957 17.9946C21.5586 17.9846 21.4269 17.9372 21.315 17.8575L17.25 14.955V18C17.25 18.3978 17.092 18.7794 16.8107 19.0607C16.5294 19.342 16.1478 19.5 15.75 19.5Z"
              fill="#557EFB"
            />
          </svg>
          <span @click="openSessions" class="text" style="vertical-align: top;">
            Launch Sessions
          </span>
          <!--                </button>-->
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="showHelp"
          v-b-toggle.sidebar-help
        >
          <span class="text">
            Book A Session
          </span>
        </b-button>
        <div class="notification">
          <span @click="notificationPanel = !notificationPanel">
            <svg
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 20C9.6193 20.0008 10.2235 19.8086 10.7285 19.4502C11.2335 19.0917 11.6143 18.5849 11.818 18H6.182C6.38566 18.5849 6.76648 19.0917 7.27151 19.4502C7.77654 19.8086 8.3807 20.0008 9 20ZM16 12.586V8C16 4.783 13.815 2.073 10.855 1.258C10.562 0.52 9.846 0 9 0C8.154 0 7.438 0.52 7.145 1.258C4.185 2.074 2 4.783 2 8V12.586L0.293001 14.293C0.199958 14.3857 0.126171 14.4959 0.0758854 14.6172C0.0256001 14.7386 -0.000189449 14.8687 1.04767e-06 15V16C1.04767e-06 16.2652 0.105358 16.5196 0.292894 16.7071C0.480431 16.8946 0.734785 17 1 17H17C17.2652 17 17.5196 16.8946 17.7071 16.7071C17.8946 16.5196 18 16.2652 18 16V15C18.0002 14.8687 17.9744 14.7386 17.9241 14.6172C17.8738 14.4959 17.8 14.3857 17.707 14.293L16 12.586Z"
                fill="#B3C2CB"
              />
            </svg>
            <span class="red-dot">
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle v-if="false" cx="4" cy="4" r="4" fill="#EF5C4A" />
              </svg>
            </span>
          </span>
          <div
            class="overlay"
            v-if="notificationPanel"
            @click="notificationPanel = false"
          ></div>
          <transition name="fade">
            <div class="notifications-panel" v-if="notificationPanel">
              <div class="d-flex justify-content-between align-items-center">
                <h4 class="title">Notifications</h4>
                <a v-if="false" class="see-all" href="">See All</a>
              </div>

              <div
                class="noti-msg"
                v-for="(noti, index) in notifications"
                :class="{ 'no-border': index == 0 }"
                :key="index"
              >
                <div class="usr-img">
                  <img :src="noti.usrImg" alt="" />
                </div>
                <div class="noti-info">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <h3 class="name">{{ noti.username }}</h3>
                    <h6 class="time">{{ noti.timestamp }}</h6>
                  </div>
                  <h6 class="usr-msg">Lorem ipsum dolor sit amet</h6>
                  <div
                    class="actions d-flex justify-content-start align-items-center"
                    v-if="noti.actions"
                  >
                    <a
                      :href="noti.actions.accept"
                      class="btn btn-primary btn-sm"
                      >Accept</a
                    >
                    <a :href="noti.actions.decline" class="btn btn-sm"
                      >Decline</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div class="profile">
          <div @click="profilePanel = !profilePanel">
            <img
              v-if="user.imgURL"
              class="avatar"
              :src="user.imgURL"
              :alt="user.firstname"
            />
            <b-avatar
              v-else
              class="avatar"
              :text="getInitials(user.firstname, user.lastname)"
            />
            <span class="username">
              {{ user.firstname }}
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.52876 5.52861C3.78911 5.26826 4.21122 5.26826 4.47157 5.52861L8.00016 9.0572L11.5288 5.52861C11.7891 5.26826 12.2112 5.26826 12.4716 5.52861C12.7319 5.78896 12.7319 6.21107 12.4716 6.47141L8.47157 10.4714C8.21122 10.7318 7.78911 10.7318 7.52876 10.4714L3.52876 6.47141C3.26841 6.21107 3.26841 5.78896 3.52876 5.52861Z"
                  fill="#557EFB"
                />
              </svg>
            </span>
          </div>
          <div
            class="overlay"
            v-if="profilePanel"
            @click="profilePanel = false"
          ></div>
          <transition name="fade">
            <div class="profile-panel" v-if="profilePanel">
              <ul>
                <li @click="handleMeClick">
                  <span>Me</span>
                </li>
                <li @click="handleProductTourClick">
                  <span>Product Help</span>
                </li>
                <hr />
                <li class="item logout" @click="signOut">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.58334 3.66659C4.34023 3.66659 4.10707 3.76316 3.93516 3.93507C3.76325 4.10698 3.66668 4.34014 3.66668 4.58325V17.4166C3.66668 17.6597 3.76325 17.8929 3.93516 18.0648C4.10707 18.2367 4.34023 18.3333 4.58334 18.3333H8.25001C8.75627 18.3333 9.16668 18.7437 9.16668 19.2499C9.16668 19.7562 8.75627 20.1666 8.25001 20.1666H4.58334C3.854 20.1666 3.15452 19.8769 2.6388 19.3611C2.12307 18.8454 1.83334 18.1459 1.83334 17.4166V4.58325C1.83334 3.85391 2.12307 3.15443 2.6388 2.63871C3.15452 2.12298 3.854 1.83325 4.58334 1.83325H8.25001C8.75627 1.83325 9.16668 2.24366 9.16668 2.74992C9.16668 3.25618 8.75627 3.66659 8.25001 3.66659H4.58334Z"
                      fill="#EF5C4A"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.0185 5.76849C14.3765 5.4105 14.9569 5.4105 15.3148 5.76849L19.8982 10.3518C20.2562 10.7098 20.2562 11.2902 19.8982 11.6482L15.3148 16.2315C14.9569 16.5895 14.3765 16.5895 14.0185 16.2315C13.6605 15.8735 13.6605 15.2931 14.0185 14.9352L17.9536 11L14.0185 7.06485C13.6605 6.70687 13.6605 6.12647 14.0185 5.76849Z"
                      fill="#EF5C4A"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.33334 10.9999C7.33334 10.4937 7.74375 10.0833 8.25001 10.0833H19.25C19.7563 10.0833 20.1667 10.4937 20.1667 10.9999C20.1667 11.5062 19.7563 11.9166 19.25 11.9166H8.25001C7.74375 11.9166 7.33334 11.5062 7.33334 10.9999Z"
                      fill="#EF5C4A"
                    />
                  </svg>
                  <span>Sign Out</span>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
      <!--        </div>-->
    </b-navbar>
    <tutorial-and-tour ref="tour"></tutorial-and-tour>
  </div>
</template>

<script>
import { quotes } from "./_quotes.json";
import TutorialAndTour from "@/components/common/tutorialAndTour";

export default {
  name: "Topbar",
  components: {
    TutorialAndTour
  },
  data() {
    return {
      helpModal: false,
      notificationPanel: false,
      notifications: [],
      profilePanel: false,
      quote: null,
      quotes
    };
  },
  created() {
    this.generateQuote();
  },
  computed: {
    user() {
      return this.$store.state.user.profile;
    }
  },
  methods: {
    handleProductTourClick() {
      this.$refs.tour.startTutoial();
    },
    generateQuote() {
      if (quotes) {
        const randIdx = Math.floor(Math.random() * this.quotes.length);
        this.quote = this.quotes[randIdx];
      }
    },
    handleMeClick() {
      this.$router.push("/me");
    },
    showHelp() {
      this.$emit("showHelp");
    },
    openSessions() {
      const windowFeatures2 =
        "width=1280,height=720,toolbar=no, menubar=no, resizable=yes";
      window.open("sessions", "newwindow", windowFeatures2);
    },
    getInitials(fname, lname) {
      let initials = "";
      if (fname) initials += fname[0];
      if (lname) initials += lname[0];
      return initials;
    },
    signOut() {
      this.$store
        .dispatch("user/signOutAction")
        .then(result => {
          this.$router.push("/signin");
        })
        .catch(err => {
          alert("Oops. " + err.message);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: 60px;
  box-shadow: 0px -2px 8px 0px #ccc;
  display: flex;
  align-items: center;
  position: fixed;
  width: calc(100% - 60px);
  background: white;
  z-index: 7;

  .nav-item-content {
    width: 100%;
    padding: 0 20px;
  }

  .qoute {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .qoute-coma {
      margin-top: -2px;
      margin-right: 10px;
    }
    h4 {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #474d52;
      margin: 0;
    }
  }
  .hamburger {
    margin: 0 10px;
    cursor: pointer;
  }
  .actions {
    button,
    div {
      margin: 0 10px;
    }
    button {
      padding: 8px 15px;
      font-size: 16px;
      line-height: 22px;
      height: 44px;
      .text {
        margin-left: 3px;
        vertical-align: middle !important;
      }
    }
    .overlay {
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: rgba(189, 189, 189, 0);
      z-index: 8;
    }
    .notification {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      span {
        cursor: pointer;
      }
      .red-dot {
        position: absolute;
        top: -6px;
        left: 50%;
      }

      .notifications-panel {
        z-index: 10;
        padding: 20px 10px;
        position: absolute;
        border-radius: 10px;
        width: 316px;
        top: 40px;
        right: -100px;
        background-color: #fff;
        box-shadow: 0px 0px 8px 0 #eee;
        div {
          margin: 0;
        }
        .title {
          font-weight: bold;
          font-size: 14px;
          line-height: 19px;
          /* identical to box height */

          /* Secondary */

          color: #8d99a0;
        }
        .see-all {
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          /* identical to box height */

          /* Primary */

          color: #557efb;
          text-decoration: none;
        }
        .noti-msg {
          padding: 10px 0;
          border-top: 2px solid #d9d9d9;
          &.no-border {
            border: none;
          }
          display: grid;
          grid-template-columns: 45px 1fr;
          .name {
            font-size: 14px;
            line-height: 19px;
            font-weight: bold;
            color: #474d52;
          }
          .time {
            font-family: "Nunito", sans-serif;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: #8d99a0;
          }
          .usr-msg {
            font-weight: normal;
            font-size: 14px;
            line-height: 19px;
            color: #474d52;
            /*margin-top: 6px;*/
          }
          .btn-fill,
          .btn-outline {
            /*margin-top: 12px;*/
            margin-left: 0;
            padding: 5px 15px;
            border-radius: 5px;
            text-decoration: none;
            font-weight: normal;
            font-size: 14px;
          }
          .btn-outline {
            border: none;
            &:hover {
              color: #557efb;
            }
          }
          .btn-fill {
            &:hover {
              color: #fff;
            }
          }
          .usr-img {
            img {
              height: 40px;
              width: 40px;
              object-fit: cover;
              border-radius: 50%;
            }
          }
        }
      }
    }
    .profile {
      position: relative;
      & > div {
        cursor: pointer;
      }
      .avatar {
        height: 40px;
        width: 40px;
        object-fit: cover;
        border-radius: 50%;
      }
      span {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        font-family: "Nunito", sans-serif;
        color: #474d52;
        margin-left: 10px;
      }
      .profile-panel {
        z-index: 10;
        position: absolute;
        top: 40px;
        right: -25px;
        background-color: #fff;
        padding: 10px 5px;
        width: 205px;
        box-shadow: 0px 0px 8px 0 #eee;
        border-radius: 10px;

        ul {
          padding: 0;
          list-style-type: none;
          li {
            display: block;
            padding: 8px;
            a {
              font-weight: 700;
              text-decoration: none;
              font-family: "Nunito", sans-serif;

              span {
                font-size: 14px;
                line-height: 19px;
                color: #474d52;
              }
              &:hover {
                background: red;
                box-shadow: none !important;
              }
            }
            &:hover {
              background: #cad0d6;
            }
            &.logout {
              color: red;
            }
          }
          .divider {
            border-top: 1px solid #b3c2cb;
            width: 205px;
            margin-left: -6px;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

@media (max-width: 1500px) {
}
@media (max-width: 1440px) {
  .qoute {
    h4 {
      display: block;
    }
  }
}
@media (max-width: 1160px) {
  .top-bar {
    .qoute {
      h4 {
        display: none;
      }
      .qoute-coma {
        display: none;
      }
    }

    .hamburger {
      /*margin: 0 10px;*/
      float: left !important;
      /*ma*/
    }
  }
}

@media (max-width: 768px) {
  .actions {
    button {
      width: unset !important;
      .text {
        display: none;
      }
    }

    .username {
      display: none;
    }
  }
}

@media (max-width: 558px) {
  .top-bar .actions button,
  .top-bar .actions div {
    margin: 0 4px;
  }
  .top-bar .actions button {
    padding: 4px 10px;
  }
  .top-bar .actions .notification {
    /*position: unset;*/
    .notifications-panel {
      position: fixed;
      width: 100%;
      right: 0;
      left: 0;
      top: 60px;
      bottom: 0;
    }
  }
  .top-bar .actions .profile .profile-panel {
    right: 0;
  }
}

@media (min-width: 1440px) {
  .top-bar {
    width: calc(100% - 234px);
  }
  .top-bar.full {
    width: calc(100% - 60px);
  }
}
/*button:hover,*/
/*a:hover{*/
/*    box-shadow: 0px 2px 6px 0px #cbcbcb;*/
/*    cursor: pointer;*/
/*}*/
</style>
